'use client';

import { c as _c } from "react/compiler-runtime";
import { SvgBookmarkFill, SvgBookmarkOutline } from '@common/icon';
import { cn } from '@core/utils';
import { useState } from 'react';
import styles from './BookmarkButton.module.scss';
interface BookmarkButtonProps {
  bookmarkCount?: number;
  isBookmarked?: boolean;
  onClick?: (isBookmarked: boolean) => void;
}
export const BookmarkButton = t0 => {
  const $ = _c(16);
  const {
    isBookmarked: t1,
    onClick
  } = t0;
  const isBookmarked = t1 === undefined ? false : t1;
  const [isCelebrating, setIsCelebrating] = useState(false);
  let t2;
  if ($[0] !== isBookmarked || $[1] !== onClick) {
    t2 = event => {
      event.preventDefault();
      setIsCelebrating(!isBookmarked);
      onClick?.(isBookmarked);
    };
    $[0] = isBookmarked;
    $[1] = onClick;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== isBookmarked || $[4] !== isCelebrating) {
    t3 = isBookmarked ? <SvgBookmarkFill fill="none" className={cn("size-14 fill-none text-B-500", isCelebrating && styles.pop)} /> : <SvgBookmarkOutline originalFill={true} className={cn("size-14")} />;
    $[3] = isBookmarked;
    $[4] = isCelebrating;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== isCelebrating) {
    t4 = isCelebrating ? <span aria-hidden={true} className={cn("absolute inset-0 rounded-pill border border-B-300", styles.burst)} onAnimationEnd={() => setIsCelebrating(false)} /> : null;
    $[6] = isCelebrating;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <span className="relative size-14 flex-center">{t3}{t4}</span>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span className="text-Gray-700 typo-body4">스크랩</span>;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== isBookmarked || $[13] !== t2 || $[14] !== t5) {
    t7 = <div className="flex items-center gap-10"><button aria-pressed={isBookmarked} className="group h-36 gap-4 rounded-pill border border-Gray-300 px-16 transition-colors duration-200 flex-center active:bg-Gray-50" type="button" onClick={t2}>{t5}{t6}</button></div>;
    $[12] = isBookmarked;
    $[13] = t2;
    $[14] = t5;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};